export default __webpack_public_path__ + "085cb93e613ba3d40d2b7b7df71371fa.woff2";